import { ellipsisClasses } from 'components/common/Pagination/Pagination.classes';

/** Truncation ellipsis cell (`…`) shown between non-adjacent page numbers. */
export const PaginationEllipsis = () => <span className={ellipsisClasses}>…</span>;
